"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fromDuration = fromDuration;
exports.toDuration = toDuration;

var _long = require("./long");

function toDuration(duration) {
  return {
    seconds: _long.Long.fromNumber(Math.floor(parseInt(duration) / 1000000000)),
    nanos: parseInt(duration) % 1000000000
  };
}

;

function fromDuration(duration) {
  return (parseInt(duration.seconds) * 1000000000 + duration.nanos).toString();
}

;